import React from 'react';
import { RoomData } from '@/AppRedux/actions/booking/bookingApiType';
import { GoogleHotelSearch } from './types';

interface HotelRoomPriceMetaProps {
  rooms: RoomData[];
  search: GoogleHotelSearch;
  currency: string;
  checkInTime?: string;
  checkOutTime?: string;
}

const stripHtml = (html: string) => html.replace(/<[^>]*>/g, '').trim();

const HotelRoomPriceMeta: React.FC<HotelRoomPriceMetaProps> = ({ rooms, search, currency, checkInTime, checkOutTime }) => (
  <>
    {rooms.map((room) => (
      <div
        key={room.roomtype_id}
        itemProp="containsPlace"
        itemScope
        itemType="https://schema.org/HotelRoom https://schema.org/Product"
      >
        <meta itemProp="identifier" content={room.roomtype_code} />
        <meta itemProp="name" content={room.roomtype_name} />
        {room.room_description && <meta itemProp="description" content={stripHtml(room.room_description)} />}
        {(room.room_images?.length ? room.room_images : room.room_cover_image ? [room.room_cover_image] : []).map((url) => (
          <meta key={url} itemProp="image" content={url} />
        ))}

        {room.rates.map((rate) => (
          <div
            key={rate.rate_id}
            itemProp="offers"
            itemScope
            itemType="https://schema.org/Offer https://schema.org/LodgingReservation"
          >
            <meta itemProp="identifier" content={rate.rate_code} />
            <meta itemProp="name" content={rate.rateplan_name} />
            {/* TODO: no real check-in/check-out time source exists yet — using date only until HotelSettings exposes one */}
            <meta itemProp="checkinTime" content={checkInTime ? `${search.startDate}T${checkInTime}` : search.startDate} />
            <meta itemProp="checkoutTime" content={checkOutTime ? `${search.endDate}T${checkOutTime}` : search.endDate} />

            <link itemProp="availability" href={room.room_avail <= 0 ? 'https://schema.org/SoldOut' : 'https://schema.org/InStock'} />
            <span itemProp="priceCurrency" content={currency}>{currency}</span>
            <span itemProp="price">{rate.room_rate.toFixed(2)}</span>
            <div itemProp="priceSpecification" itemScope itemType="https://schema.org/CompoundPriceSpecification">
              <span itemProp="priceCurrency" content={currency}>{currency}</span>
              <span itemProp="price">{rate.room_rate.toFixed(2)}</span>
            </div>
          </div>
        ))}
      </div>
    ))}
  </>
);

export default HotelRoomPriceMeta;
